import { HttpError, useCustomMutation } from "@refinedev/core";
import {
  CreateMediaGenerationSettingsRequest,
  MediaGenerationSettingsResponse,
} from "pages/media/types";

const useHeyGeniusSaveMediaSettings = () => {
  const { mutateAsync } = useCustomMutation<
    MediaGenerationSettingsResponse,
    HttpError,
    CreateMediaGenerationSettingsRequest
  >();

  const saveMediaSettings = async (
    organizationId: string,
    projectId: string,
    instanceId: string,
    width: number = 400,
    height: number = 400,
    templateId: string = "heygenius"
  ) => {
    if (!instanceId || !projectId || !organizationId) return;
    await mutateAsync({
      url: `media/${organizationId}/projects/${projectId}/media/${instanceId}/settings`,
      method: "post",
      values: {
        chapter_template_id: templateId,
        chapters: [],
        width,
        height,
      },
    });
  };

  return saveMediaSettings;
};

export default useHeyGeniusSaveMediaSettings;
